app.controller(
    'AdminZoneRubricController', ['$scope', '$rootScope', '$http', '$stateParams', 'Configuration', 'UserService', '$translate', 'AdminService', AdminZoneRubricController]
);

function AdminZoneRubricController($scope, $rootScope, $http, $stateParams, Configuration, UserService, $translate, AdminService) {
    var vm = this;

    $scope.ZoneRubric = {
        ResponsableEditionFRList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        ResponsableEditionENList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        AuthorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        TranslatorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        CorrectorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
    };

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = 1;
    }

    initController();

    function initController() {
        getAdminZoneRubric(vm.ParamZoneId, $scope.CurrentLang);
    }

    function getAdminZoneRubric(zoneId, lang) {
        AdminService.getAdminZoneInfo(zoneId, lang)
            .then(function (zone) {
                $scope.ZoneRubric = zone.data;
                $rootScope.ZoneRubric = angular.copy(zone.data);
            });
    }

    vm.UpdateAdminCityRubric = function (zoneRubric) {
        // console.log(zoneRubric);
        AdminService.UpdateAdminCityRubric(zoneRubric)
            .then(
                function success(data) { },
                function error(data) { });
    }

    // [Lam Hong 29-Jul-2025] LVCG-198: FIX the Listing of rubrics on the Guides edit forms.
    vm.ShowRubricKeyWord = function (rubric) {
        var rubricTitle = rubric.RubricTitle;
        if (!rubricTitle) {
            return '';
        } else if (rubricTitle.startsWith('Hôtels')) {
            return 'hotels';
        } else if (rubricTitle.startsWith('Restaurants')) {
            return 'restaurants';
        } else if (rubricTitle.startsWith('Bonne choses')) {
            return 'bonnesChosesPetitesFaims';
        } else if (rubricTitle.startsWith('Bar, Cafés et Salons')) {
            return 'barCafesSalonsThe';
        } else if (rubricTitle.startsWith('Nuits')) {
            return 'nuits';
        } else if (rubricTitle.startsWith('Affaires de style')) {
            return 'affairesStyle';
        } else if (rubricTitle.startsWith('Objets de qualité')) {
            return 'objetsQualite';
        } else if (rubricTitle.startsWith('Art et cultures')) {
            return 'artsCultures';
        } else if (rubricTitle.startsWith('La ville mode')) {
            return 'laVilleModeEmploi';
        } else {
            return rubricTitle;
        }
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };
}